import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Footer from './components/Footer';
import Modal from './components/Modal';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import PLGO from './components/PLGO';
import HomePage from './pages/HomePage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import LoginPage from './pages/LoginPage';
import OnboardingPage from './pages/OnboardingPage';
import OnboardingFormPage from './pages/OnboardingFormPage';
import DashboardPage from './pages/DashboardPage';
import Danke from './components/Danke';

function App() {
  const [modalContent, setModalContent] = useState(null);

  const openModal = (content) => {
    setModalContent(content);
  };

  const closeModal = () => {
    setModalContent(null);
  };

  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-white text-black">
          <Routes>
            {/* Public Routes */}
            <Route
              path="/"
              element={
                <>
                  <Header />
                  <main>
                    <HomePage />
                  </main>
                  <Footer onOpenModal={openModal} />
                </>
              }
            />
            
            {/* Legal Pages */}
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            
            <Route
              path="/danke"
              element={
                <>
                  <Header />
                  <main>
                    <Danke />
                  </main>
                  <Footer onOpenModal={openModal} />
                </>
              }
            />
            <Route path="/onboarding-form" element={<OnboardingFormPage />} />

            {/* Authentication Routes */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected Routes */}
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <OnboardingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
          </Routes>

          <AnimatePresence>
            {modalContent && (
              <Modal onClose={closeModal}>
                {modalContent === 'impressum' && <Impressum />}
                {modalContent === 'datenschutz' && <Datenschutz />}
                {modalContent === 'plgo' && <PLGO />}
              </Modal>
            )}
          </AnimatePresence>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;